import SearchModule from "components/SearchModule";
import * as routes from "constants/routes";
import { useCheckBox } from "hooks/useCheckBox";
import useFilter from "hooks/useFilter";
import _ from "lodash";
import { useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { fetchSubmittedProducts } from "redux/productDate/productDate";
import PaginatedTable from "../../components/Table/PaginatedTable";
import { MODULES } from "../../constants/modules";
import { TreatmentTable } from "./TreatmentTable";

const Treatment = ({ active, permissionList, isDeleted }: any) => {
  const {
    filter: filterOptions,
    actions: { handleSize, handlePagination, handleSearch, handleSort },
  } = useFilter({
    ordering: "id",
  });
  const history = useHistory();

  const { page, paginate_by, ordering: sortField, search: searchQuery } = filterOptions;

  const [refresh, setRefresh] = useState(false);

  const { data, isLoading, refetch, isFetching } = useQuery(
    ["projects", active, filterOptions],
    () => fetchSubmittedProducts(filterOptions),
    {
      keepPreviousData: true,
    },
  );

  const pageData = data && !_.isEmpty(data?.data) ? data?.data : [];

  const pageCount = (data && data?.count) || 0;
  const totalCount = (data && data?.total_count) || 0;
  const current_page_number = (data && data?.current_page_number) || 0;

  const { checkAll, allChecked } = useCheckBox(page || 1, pageData, refresh, setRefresh);

  return (
    <>
      <div className="page">
        <div className="module-header">
          <div className="module-name">Submitted Product Module</div>
          <div className="module-action">
            <SearchModule handleSearch={handleSearch} />
          </div>
        </div>
        <PaginatedTable
          cols={TreatmentTable((rowData: any) => history.push(routes.TREATMENT + `/${rowData?.id}`))}
          data={pageData}
          isDark={false}
          bordered
          striped={false}
          hoverable
          entries={paginate_by || 10}
          onRowClick={() => {}}
          //selected={selectedRowID}
          componentName={MODULES.TREATMENT}
          handlePagination={handlePagination}
          handleEntries={handleSize}
          currentPage={current_page_number}
          totalCount={totalCount}
          size="lg"
          isDataLoading={isFetching || isLoading}
          handleSort={handleSort}
          initialSortConfig={{ key: sortField || "", direction: "desc" }}
          allChecked={allChecked}
          checkAll={checkAll}
          isPaginationRequired={true}
        />
      </div>
    </>
  );
};

export default Treatment;
